import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "settings",
  transform: "translate(0 0)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Tracé_383",
    "data-name": "Tracé 383",
    d: "M29.883,18.561V16.87l2.122-1.856a2.21,2.21,0,0,0,.419-2.818l-2.608-4.42A2.228,2.228,0,0,0,27.2,6.782l-2.685.906a12.542,12.542,0,0,0-1.448-.829L22.5,4.074a2.21,2.21,0,0,0-2.21-1.779H15.12a2.21,2.21,0,0,0-2.21,1.779l-.564,2.785a12.685,12.685,0,0,0-1.459.829L8.258,6.737a2.21,2.21,0,0,0-.706-.066A2.21,2.21,0,0,0,5.64,7.776L3.032,12.2a2.21,2.21,0,0,0,.453,2.774l2.088,1.911v1.69L3.485,20.428a2.21,2.21,0,0,0-.453,2.818l2.608,4.42a2.228,2.228,0,0,0,2.619.994l2.685-.906a12.542,12.542,0,0,0,1.448.829l.564,2.785a2.21,2.21,0,0,0,2.21,1.779h5.216a2.21,2.21,0,0,0,2.21-1.779l.564-2.785a12.685,12.685,0,0,0,1.459-.829l2.675.906a2.228,2.228,0,0,0,2.619-.994l2.519-4.42a2.21,2.21,0,0,0-.453-2.774Zm-1.978,8-3.79-1.282a9.79,9.79,0,0,1-2.995,1.735l-.784,3.967H15.121l-.785-3.923a10.343,10.343,0,0,1-2.984-1.735l-3.8,1.238-2.608-4.42,3.006-2.652a9.835,9.835,0,0,1,0-3.458L4.944,13.3l2.608-4.42,3.79,1.282a9.79,9.79,0,0,1,2.995-1.735l.784-3.967h5.216l.785,3.923a10.343,10.343,0,0,1,2.984,1.735l3.8-1.238,2.608,4.42-3.006,2.652a9.835,9.835,0,0,1,0,3.458l3.006,2.73Z",
    transform: "translate(-2.714 -2.295)",
    fill: "#fff"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Tracé_384",
    "data-name": "Tracé 384",
    d: "M17.88,24.51a6.564,6.564,0,1,1,4.708-1.922A6.63,6.63,0,0,1,17.88,24.51Zm0-11.05a4.321,4.321,0,0,0-4.42,4.42,4.321,4.321,0,0,0,4.42,4.42,4.321,4.321,0,0,0,4.42-4.42,4.321,4.321,0,0,0-4.42-4.42Z",
    transform: "translate(-2.866 -2.454)",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}